import React from 'react';
import { Card, CardHeader, CardContent } from '../../components/ui/Card';
import { BarChart3, TrendingUp, Users, DollarSign } from 'lucide-react';

export default function AdminAnalyticsPage() {
  return (
    <div className="space-y-6 animate-fade-in">
      <div><h1 className="text-2xl font-bold text-white">Analytics</h1><p className="text-sm text-slate-400">Platform analytics and insights</p></div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        {[
          { title: 'Revenue Trend', icon: DollarSign },
          { title: 'User Growth', icon: Users },
          { title: 'Investment Volume', icon: TrendingUp },
          { title: 'Commission Distribution', icon: BarChart3 },
        ].map((chart, i) => (
          <Card key={i}>
            <CardHeader><h2 className="text-sm font-semibold text-white">{chart.title}</h2></CardHeader>
            <CardContent><div className="h-48 flex items-center justify-center bg-white/[0.02] rounded-lg">
              <div className="text-center"><chart.icon className="w-8 h-8 text-slate-600 mx-auto mb-1" /><p className="text-xs text-slate-500">Chart data loads from API</p></div>
            </div></CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}